import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnPH: CultureInfo = {
  name: 'en-PH',
  displayName: 'English (Philippines)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-PH',
  parent: CultureInfoEn
};
